'use client';

import { useLocaleStore } from '@/client/stores/useLocaleStore';
import { cn } from '@/utils';
import { ClassValue } from 'clsx';
import Link from 'next/link';

interface Props {
  className?: ClassValue;
}

export function PrivacyPolicyLink({ className }: Props) {
  const { locale } = useLocaleStore();
  const text = locale === 'en' ? 'Privacy Policy' : '개인정보 처리방침';
  const font = locale === 'en' ? 'font-mono' : 'font-sans';

  return (
    <Link href={'/privacy-policy'}>
      <span className={cn(`flex h-full items-center justify-center ${font}`, className)}>{text}</span>
    </Link>
  );
}
